var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"conditional-section__hide-form-information"},[_c('Message',{attrs:{"type":"info"}},[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }